import React, { FC } from 'react';
// images
import SMBLogo from '../../assets/logos/SMB_Logo_WithTM.png';
import RabrenLogo from '../../assets/logos/Logo-Rabren.png';

const { isRabren } = require('../../buildSettings.json');

interface ILogoProps {
  className?: string;
}

export const FullLogoWidth = 120;
export const FullLogoHeight = 64;

export const Logo: FC<ILogoProps> = ({ className }) => {
  return <img src={isRabren === 'true' ? RabrenLogo : SMBLogo} alt="logo" className={className} />;
};
